import { FC, useState } from "react";
import styled from "styled-components";
import { DateTime } from "luxon";

import FiltersDropdown from "@/components/FilterDropdown";
import FilterButton from "@/components/FilterDropdown/FilterButton";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import {
  FilterGroupBody,
  FilterGroupHeader,
  FilterGroupTitle,
  FilterWrap,
} from "@/components/FilterDropdown/Parts";

const StyledFiltersDropdown = styled(FiltersDropdown)`
  max-height: 418px;
`;

interface Props {
  activePeriod: string;
  setActivePeriod: React.Dispatch<React.SetStateAction<string>>;
}

export const months = (() => {
  const months = [];

  let currentDate = DateTime.now();

  while (currentDate.diffNow("months").months > -12) {
    months.push(currentDate);
    currentDate = currentDate.minus({ months: 1 });
  }

  return months;
})();

const ParticipantsScoreDateFilter: FC<Props> = ({
  activePeriod,
  setActivePeriod,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <FilterWrap>
      <FilterButton
        text="Date"
        isActive={showFilters}
        onClick={(e) => {
          e?.stopPropagation();
          setShowFilters((prev) => !prev);
        }}
        filterApplied
      />
      {showFilters && (
        <StyledFiltersDropdown onClose={() => setShowFilters(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>By Month:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            {months.map((dt, index) => (
              <FilterRadioButton
                key={index}
                id={`monthRadio${index}`}
                value={dt.startOf("month").toFormat("yyyy-LL-dd")}
                checked={
                  activePeriod === dt.startOf("month").toFormat("yyyy-LL-dd")
                }
                setValue={(newValue) => setActivePeriod(newValue)}
              >
                {dt.toFormat("yyyy LLLL")}
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
        </StyledFiltersDropdown>
      )}
    </FilterWrap>
  );
};

export default ParticipantsScoreDateFilter;
